module.exports = "/assets/data/cd85846fed02d5803615c874aeef3f9a-NW1.data.json";